"use client";
import styled from "../../../client-utils/styled/index.js";
import ChipAtom from "../../../components/atoms/Chip/index.js";
const coreComponentName = "SdbPrintModifierKey";
export const Root = styled("span", { name: coreComponentName, slot: "Root" })({
    display: "inline-flex",
    flexWrap: "nowrap",
    alignItems: "center",
    gap: 4,
    "@media (hover: none) and (pointer: coarse)": {
        display: "none",
    },
});
export const Chip = styled(ChipAtom, { name: coreComponentName, slot: "Chip" })(({ theme }) => ({
    borderRadius: 4,
    backgroundColor: theme.vars.palette.surface.containerHighest,
}));
